<template>
  <b-table
    hover
    small
    caption-top
    responsive="sm"
    :items="guests"
    :fields="tableFields"
  >
  
    <template #cell(situation)="{item}">
      <slot name="situation" :guest="item"/>
    </template>

    <template #cell(type)="data">
      <span v-if="data.item.type === 'user' || data.item.entity_type === 'App\\Models\\User'">Usuário</span>
      <span v-else-if="data.item.type === 'legal_entity' || data.item.entity_type === 'App\\Models\\Corp\\LegalEntity'">Pessoa Jurídica</span>
      <span v-else-if="data.item.type === 'external_entity' || data.item.is_external">Externo</span>
      <span v-else-if="data.item.type === 'contact_list' || data.item.entity_type === 'App\\Models\\Corp\\ContactList'">Lista</span>
      <span v-else>Unidade Organizacional</span>
      
    </template>

    <template #cell(name)="data">
      <span>{{getEntityName(data)}}</span>
    </template>

    <template #cell(email)="data">
      <span>{{getEntityEmail(data)}}</span>
    </template>

    <template #cell(confirmed)="data">
      <div class="text-lg text-center flex gap-1 items-center">
        <b-button v-tooltip="{content:'Abrir justificativa', duration:{show:100, hide:100}}" @click="openJustifications(data.item)" v-if="guestHasJustifications(data.item)" pill size="sm" variant="outline-warning">
          <b-icon-exclamation-triangle font-scale="1" class="text-warning"/>
        </b-button>
        <b-icon-check v-if="data.item.confirmed" key="confirmed" font-scale="2" class="text-success"/>
        <b-icon-x v-else-if="!guestHasJustifications(data.item)" key="unconfirmed" font-scale="2" class="text-danger"/>
        
      </div>
    </template>

    <template #cell(action)="data">
      <feather-icon
        v-if="showActions"
        @click="removeGuest(data.item)"
        icon="XCircleIcon"
        size="21"
        class="h-5 w-5 mr-3 stroke-current text-danger cursor-pointer"
      />
    </template>
  </b-table>
</template>

<script>
import {
  BTable,
  BIconCheck,
  BIconX,
  BIconExclamationTriangle,
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BIconCheck,
    BIconX,
    BIconExclamationTriangle,
    BButton,
  },

  props: {
    guests: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => [
        { key: 'type', label: 'Tipo' },
        { key: 'name', label: 'Nome' },
        { key: 'email', label: 'Email'},
        { key: 'confirmed', label: 'Confirmado'}
      ]
    },
  },

  data: () => ({
  }),

  computed: {
    tableFields() {
      const fields = [...this.fields]
      if (this.showActions) {
        fields.push({ key: 'action', label: 'Ação' })
      }
      return fields
    }
  },

  methods: {
    openJustifications(guest) {
      this.$emit('open-justifications', guest)
    },
    removeGuest(guest) {
      this.$emit('remove-guest', guest)
    },
    getEntityName(data) {
      let item = data.item
      const type = item && item.type || item.entity_type
      if (type) {
        if (type == 'legal_entity' || type == 'App\\Models\\Corp\\LegalEntity') {
          if ('entity' in item && item.entity) {
            item = item.entity
          }
          return `${item.company_name} - ${item.trading_name} (${this.cnpjFormat(item.cnpj)})`
        } else if (type == 'user' || type == 'App\\Models\\User') {
          if ('entity' in item && item.entity) {
            item = item.entity
          }
          return item.name
        }

        return item.name || item.label || (item.entity && item.entity.name ) || item.name || '-'
      }
      return '...'
    },
    getEntityEmail(data) {
      const email = data.item.email
      if (this._.isArray(email)) {
        if (email.length > 0) {
          return email[0]
        } else {
          return ''
        }
      } else {
        return email
      }
    },
    guestHasJustifications(guest) {
      return (guest && guest.justifications && this._.isArray(guest.justifications) && guest.justifications.length > 0) || false
    },
  }
}
</script>

<style>

</style>